import { IPhoenixSocketController } from '@caudena/api/WebSocket'
import { DI_TYPES } from '@caudena/api/DI/types'
import { phoenixSocketControllerContainer } from '@caudena/api/DI/socketControllerModule'

const phoenixSocketController =
  phoenixSocketControllerContainer.get<IPhoenixSocketController>(
    DI_TYPES.PhoenixSocketController
  )
export default phoenixSocketController
